import React from 'react';
import common from '../common/common';
function LoadingComponent({ styles }) {
  return (
    <div style={styles}>
      <img
        src={common.contentFromCdn({
          path: '/content/img/preload-grey.svg',
          keepUrlAsIs: false,
        })}
      ></img>
    </div>
  );
}

export default LoadingComponent;
